<template>
  <div
    :class="{ is_mobile: !$tools.isPc() }"
    class="page_middle_container page_middle_project_detail"
  >
    <div class="page_middle_title">项目号申请审批</div>
    <div class="page_middle_content">
      <div class="page_middle_body">
        <div class="page_middle_second_title" style="font-weight: bold">
          项目立项
        </div>
        <div class="page_middle_row">
          <div class="page_middle_row_td">
            <div class="page_middle_row_key">
              <span class="page_middle_row_key_required">*</span>公司名称：
            </div>
            <div class="page_middle_row_value">
              <div class="watch-text-color">
                <el-input
                  disabled
                  type="text"
                  v-model.trim="data.company"
                ></el-input>
              </div>
            </div>
          </div>
        </div>
        <div class="page_middle_row">
          <div class="page_middle_row_td">
            <div class="page_middle_row_key">
              <span class="page_middle_row_key_required">*</span>营收类型：
            </div>
            <div class="page_middle_row_value">
              <el-radio-group disabled v-model="data.revenue_type">
                <el-radio
                  v-for="(item, index) in config.projectType"
                  :key="item"
                  :label="index"
                  size="small"
                >
                  {{ item }}</el-radio
                >
              </el-radio-group>
            </div>
          </div>
        </div>
      </div>
      <div class="page_middle_body">
        <div class="page_middle_second_title">项目基本信息</div>
        <div class="page_middle_row">
          <div class="page_middle_row_td">
            <div class="page_middle_row_key">
              <span class="page_middle_row_key_required">*</span>项目名称：
            </div>
            <div class="page_middle_row_value">
              <div class="watch-text-color">
                <el-input
                  disabled
                  type="text"
                  v-model.trim="data.project_name"
                ></el-input>
              </div>
            </div>
          </div>
        </div>
        <div class="page_middle_row">
          <div class="page_middle_row_td">
            <div class="page_middle_row_key">
              <span class="page_middle_row_key_required">*</span>项目时间段：
            </div>
            <div class="page_middle_row_value">
              <el-date-picker
                disabled
                v-model="projectDate"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="YYYY-MM-DD"
              />
            </div>
          </div>
        </div>
        <!-- 内部项目号 -->
        <div v-if="data.project_type === 0" class="page_middle_row">
          <div class="page_middle_row_td page_middle_row_td_textarea">
            <div class="page_middle_row_key">
              <span class="page_middle_row_key_required">*</span>项目内容：
            </div>
            <div class="page_middle_row_value">
              <el-input
                disabled
                :rows="5"
                type="textarea"
                v-model.trim="data.project_content"
                placeholder="请输入项目内容"
              ></el-input>
            </div>
          </div>
        </div>
        <!-- 外部项目号 -->
        <div v-else>
          <div class="page_middle_row">
            <div class="page_middle_row_td">
              <div class="page_middle_row_key">
                <span class="page_middle_row_key_required">*</span>产品：
              </div>
              <div class="page_middle_row_value">
                <el-input
                  disabled
                  v-model.trim="data.product"
                  placeholder="请输入产品"
                ></el-input>
              </div>
            </div>
          </div>
          <div class="page_middle_row">
            <div class="page_middle_row_td">
              <div class="page_middle_row_key">
                <span class="page_middle_row_key_required">*</span>领域：
              </div>
              <div class="page_middle_row_value">
                <el-input
                  disabled
                  v-model.trim="data.field"
                  placeholder="请输入领域"
                ></el-input>
              </div>
            </div>
          </div>
          <div class="page_middle_row">
            <div class="page_middle_row_td">
              <div class="page_middle_row_key">预计收入：</div>
              <div class="page_middle_row_value">
                <el-input
                  disabled
                  v-model="data.estimated_revenue"
                  placeholder="请输入预计收入"
                >
                  <template #suffix>
                    <el-tooltip
                      effect="dark"
                      :content="getChineseMoney"
                      placement="top-end"
                    >
                      <div>元(查看大写)</div>
                    </el-tooltip>
                  </template>
                </el-input>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="page_middle_body">
        <div class="page_middle_second_title">甲方信息</div>
        <div class="page_middle_row">
          <div class="page_middle_row_td">
            <div class="page_middle_row_key">
              <span class="page_middle_row_key_required">*</span>
              甲方公司：（公司全称）
            </div>
            <div class="page_middle_row_value">
              <div class="watch-text-color">
                <el-input
                  disabled
                  type="text"
                  v-model.trim="data.customer_company"
                ></el-input>
              </div>
            </div>
          </div>
        </div>
        <div class="page_middle_row">
          <div class="page_middle_row_td">
            <div class="page_middle_row_key">
              <span class="page_middle_row_key_required">*</span>客户姓名：
            </div>
            <div class="page_middle_row_value">
              <el-input
                disabled
                v-model.trim="data.customer_name"
                placeholder="请输入客户姓名"
              ></el-input>
            </div>
          </div>
        </div>
        <div class="page_middle_row">
          <div class="page_middle_row_td">
            <div class="page_middle_row_key">客户职位：</div>
            <div class="page_middle_row_value">
              <el-input
                disabled
                v-model.trim="data.customer_position"
                placeholder="请输入客户职位"
              ></el-input>
            </div>
          </div>
        </div>
        <div class="page_middle_row">
          <div class="page_middle_row_td">
            <div class="page_middle_row_key">客户手机号：</div>
            <div class="page_middle_row_value">
              <el-input
                disabled
                v-model.trim="data.customer_phone"
                placeholder="请输入客户手机号"
              ></el-input>
            </div>
          </div>
        </div>
        <div class="page_middle_row">
          <div class="page_middle_row_td">
            <div class="page_middle_row_key">客户邮箱：</div>
            <div class="page_middle_row_value">
              <el-input
                disabled
                v-model.trim="data.customer_email"
                placeholder="请输入客户邮箱"
              ></el-input>
              <!-- <div class="page_middle_row_value_tip">
                (请最少填写一种客户联系方式)
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="page_middle_body">
        <div class="page_middle_second_title">补充内容</div>
        <div class="page_middle_row">
          <div class="page_middle_row_td page_middle_row_td_textarea">
            <div class="page_middle_row_key">补充内容：</div>
            <div class="page_middle_row_value">
              <el-input
                disabled
                type="textarea"
                v-model="data.supplementary_information"
                rows="4"
                placeholder="请输入补充内容"
              ></el-input>
            </div>
          </div>
        </div>
        <div class="page_middle_row">
          <div class="page_middle_row_td page_middle_row_td_textarea">
            <div class="page_middle_row_key">附件：</div>
            <div class="page_middle_row_value" style="padding-left: 15px;">
              <div v-if="data.attachment">
                <div
                  v-for="(item, index) in data.attachment.split(',')"
                  :key="index"
                >
                  <!-- <a :href="item" target="_blank">{{
                    $tools.getFileNameFromURL(item)
                  }}</a> -->
                  <span class="global_link" @click="openLink(item)">
                    {{ $tools.getFileNameFromURL(item) }}
                  </span>
                </div>
              </div>
              <div v-else>无</div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="page_middle_body"
        v-if="data.examine_status == 0 && !query.isWatch"
        style="margin-top: 10px"
      >
        <div class="page_middle_row">
          <div class="page_middle_row_td">
            <div class="page_middle_row_key">
              <span class="page_middle_row_key_required">*</span>审批结果：
            </div>
            <div class="page_middle_row_value">
              <el-select
                v-model="auditData.examine_status"
                placeholder="请选择审批结果"
              >
                <el-option :value="1" label="通过"></el-option>
                <el-option :value="2" label="驳回"></el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="page_middle_row">
          <div class="page_middle_row_td">
            <div class="page_middle_row_key">
              <span class="page_middle_row_key_required" v-if="auditData.examine_status == 2">*</span>审批备注：
            </div>
            <div class="page_middle_row_value">
              <el-input
                v-model.trim="auditData.examine_reason"
                placeholder="请输入审批备注"
              ></el-input>
            </div>
          </div>
        </div>
        <div class="page_middle_buttongroup">
          <el-button type="primary" @click="doCommit" :loading="loading"
            >审核</el-button
          >
        </div>
      </div>
      <div class="page_middle_body" v-else style="margin-top: 10px">
        <div class="page_middle_row">
          <div class="page_middle_row_td">
            <div class="page_middle_row_key">
              审批结果：
            </div>
            <div class="page_middle_row_value" style="padding-left: 15px;display: flex;align-items: center;">
              <el-icon style="font-size: 4vw;color: #67c23a;margin-right: 5px;" v-if="data.examine_status == 1"><SuccessFilled /></el-icon>
              <el-icon style="font-size: 4vw;color: red;margin-right: 5px;" v-if="data.examine_status == 2"><CircleCloseFilled /></el-icon>
              <span>
                {{ $config.types.auditResult[data.examine_status] }}
              </span>
            </div>
          </div>
        </div>
        <div class="page_middle_row">
          <div class="page_middle_row_td">
            <div class="page_middle_row_key">
              审批备注：
            </div>
            <div class="page_middle_row_value" style="padding-left: 15px;">
              {{ data.examine_reason }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { SuccessFilled, CircleCloseFilled } from "@element-plus/icons";
export default {
  name: "page_middle",
  components: {
    SuccessFilled, 
    CircleCloseFilled 
  },
  data() {
    return {
      auditData: {
        id: "",
        examine_status: "",
        examine_reason: "",
        operation_url: window.location.href,
      },
      config: {
        projectType: this.$config.types.projectType,
      },
      data: {},
      projectDate: [], //项目时间段
      query: {},
      loading: false,
    };
  },
  created() {
    this.query = { ...this.$route.query };
  },
  computed: {
    getChineseMoney() {
      let moneyText = this.$tools.numberToChinese(this.data.estimated_revenue);
      return moneyText;
    },
  },
  mounted() {
    if (this.query.id) {
      this.initData();
    }
    // window.addEventListener(
    //   "popstate",
    //   function () {
    //     // 如果监听到返回，页面就会刷新
    //     location.reload();
    //   },
    //   false
    // );
  },
  methods: {
    initData() {
      let url = this.$tools.getURL(this.$urls.projectList.project_info, {
        id: this.query.id,
      });
      this.$axios
        .get(url)
        .then((res) => {
          this.data = res.data;
          this.auditData.id = res.data.id;
          this.projectDate = [this.data.start_time, this.data.end_time];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    openLink(url) {
      this.$tools.downLoadFile(url);
    },
    verifyData() {
      if (!this.auditData.examine_status) {
        this.$tips.error({ text: "请选择审批结果" });
        return false;
      }
      if (
        this.auditData.examine_status == 2 &&
        !this.auditData.examine_reason
      ) {
        this.$tips.error({ text: "请输入审批备注" });
        return false;
      }
      return true;
    },
    doCommit() {
      if (this.loading || !this.verifyData()) {
        return;
      }
      this.loading = true;
      let url = this.$urls.projectList.examine_project;
      this.$axios
        .post(url, this.auditData)
        .then(() => {
          setTimeout(() => {
            this.loading = false;
          }, 1000);
          this.$tips.success({ text: "审核完成" });
          this.initData();
        })
        .catch(() => {
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        });
    },

    closeInfo() {
      this.$emit("closeInfo");
    },
  },
};
</script>
<style>
.page_middle_project_detail .page_middle_row_value {
  display: flex;
  align-items: center;
}

.flex-column {
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.flex-justify-content-start {
  justify-content: start;
}

.zIndexBold {
  z-index: 1000;
  position: relative;
}

.is_mobile * {
  font-size: 1.25rem;
}

.is_mobile .page_middle_row {
  align-items: initial;
  flex-direction: column;
}

.is_mobile .page_middle_row .page_middle_row_td {
  margin-bottom: 10px;
}

.is_mobile .project_number_input {
  flex-direction: initial;
  align-items: center;
}

.is_mobile .page_middle_row_td_textarea .el-textarea {
  width: 60%;
}

.is_mobile .page_middle_row_key .page_middle_row_key_left {
  text-align: left;
  flex: 50px 0 0;
}
</style>
  